// Lëtzebuergescht Fragment vun der Produktsäit (/product/:id): Galerie,
// Kafblock, Upsell, Accessoiren, Souvenir an technesch Fiche.
// Iwwersetzung vun fr/fiche.js — genau déiselwecht Schlësselen.
// D’PRODUKTtexter (name, tagline, description, features) kommen aus der
// Datebank iwwer d’API: déi lafen iwwer tp()/tpList(), ni iwwer dës Schlësselen.
export default {
  'fiche.seo.titre': '{nom} — Joyful Reveal',
  'fiche.seo.descriptionDefaut':
    'D’Gender-Reveal-Spill Joyful Reveal: e Quiz an zwou Equipen, e Puzzle fir zesummenzeleeën an e lescht Stéck fir ze rubbelen.',
  'fiche.seo.titreIntrouvable': 'Produit net fonnt',
  'fiche.seo.titreErreur': 'Feeler beim Lueden',
  'fiche.seo.descriptionErreur': 'Dëse Produit gëtt et net méi am Shop vu Mirum Games.',

  'fiche.chargement.produit': 'De Produit gëtt gelueden…',

  'fiche.erreur.introuvableTitre': 'Dëse Pack gëtt et net méi',
  'fiche.erreur.erreurTitre': 'Lueden net méiglech',
  'fiche.erreur.introuvableTexte':
    'Vläicht gouf en ersat. Dir fannt all eis Packen am Shop.',
  'fiche.erreur.erreurTexte':
    'D’Verbindung mam Server ass feelgeschloen. Probéiert et an engem Moment nach eng Kéier.',
  'fiche.erreur.versBoutique': '🛍️ An de Shop',

  'fiche.ariane.label': 'Navigatiounspad',

  'fiche.visuels.boiteAlt':
    'Virsäit vun der Joyful-Reveal-Schachtel: zwee Bieren an d’Puzzlestéck fir ze rubbelen',
  'fiche.visuels.boiteLegende': 'D’Schachtel',
  'fiche.visuels.dosAlt':
    'Récksäit vun der Schachtel: déi 4 Etappe vum Spill, d’Sprooche vun de Regelen an de QR-Code',
  'fiche.visuels.dosLegende': 'D’Récksäit vun der Schachtel',
  'fiche.visuels.contenuAlt':
    'Inhalt vum Pack Premium: d’Schachtel, de Froebou an déi zwee Stoffsäckelcher',
  'fiche.visuels.contenuLegende': 'Wat Dir kritt',
  'fiche.visuels.pochonsAlt': 'Déi zwee Stoffsäckelcher fir déi zwou Equipen',
  'fiche.visuels.pochonsLegende': 'D’Stoffsäckelcher vun den Equipen',
  'fiche.visuels.grattageAlt': 'Eng Hand krazt mat enger Mënz dat gëllent Feld vum Puzzel fräi: d’Wuert GIRL erschéngt',
  'fiche.visuels.grattageLegende': 'D’Freirubbelen',
  'fiche.visuels.puzzleEncadreAlt':
    'De fäerdege Puzzel an engem gëllene Kader, op engem Piano tëscht zwee Käerzestänner',
  'fiche.visuels.puzzleEncadreLegende': 'De gerummte Souvenir',
  'fiche.visuels.puzzleTableAlt':
    'De fäerdege Puzzel a sengem gëllene Kader, op engem Eechendësch',
  'fiche.visuels.puzzleTableLegende': 'No der Feier',
  'fiche.visuels.questionnaireAlt':
    'De Froebou op Kart gedréckt, mat de Kolonnen Equipe 1, Equipe 2 a Elteren',
  'fiche.visuels.questionnaireLegende': 'De gedréckte Froebou',
  'fiche.visuels.voir': 'Kucken: {legende}',

  'fiche.achat.gamme': 'Joyful Reveal — Bieren',
  'fiche.achat.promesse':
    'Eelef Froen, zwou Equipen, ee Stéck fir ze rubbelen — an all entdecken et zesummen, am selwechte Moment.',
  'fiche.achat.remise': '−{n} %',
  'fiche.achat.contenuTitre': 'Wat an dësem Pack dran ass',
  'fiche.achat.ajouter': '🛒 An de Wuerekuerf leeën',
  'fiche.achat.indisponible': 'Momentan net verfügbar',
  'fiche.achat.reappro': 'Neie Stock ass ënnerwee',
  'fiche.achat.expedition': '📦 Aus der Belsch bannent 1 bis 2 Aarbechtsdeeg verschéckt',
  // Muss mat PAYS_LIVRES (frontend/src/lib/zonesLivraison.js) iwwereneestëmmen.
  'fiche.achat.livraison':
    '🚚 Liwwerung an d’Belsch, Frankräich, Lëtzebuerg, d’Nidderlanden, Däitschland a Spuenien — Versandkäschte gi beim Bezuele berechent',
  'fiche.achat.langue':
    '🇫🇷 Schachtel a Regelen op Franséisch (zweesproocheg Resumé Franséisch / Englesch op der Schachtel)',
  'fiche.achat.retour': '↩️ 14 Deeg fir Iech ëmzebesënnen',

  'fiche.genre.titre': 'Dat ass fir…',
  'fiche.genre.fille': 'Meedchen',
  'fiche.genre.garcon': 'Jong',
  'fiche.genre.mixte': 'Meedchen + Jong',
  'fiche.genre.alerte': 'Wielt fir d’éischt Meedchen oder Jong.',
  'fiche.genre.discretion':
    'Kee Mënsch ausser Iech weess et: eréischt d’Rubbelstéck verréit et.',
  'fiche.genre.packMixte': '👫 Dëse Pack enthält souwuel d’Meedchesversioun wéi och d’Jongeversioun',
  'fiche.genre.packGarcon': '👦 Jongeversioun',
  'fiche.genre.packFille': '👧 Meedchesversioun',

  // Saz a 4 Stécker, well zwou Passagen am JSX fett sinn:
  // „Fir [X méi] kritt Dir mam [NUMM] all d’Accessoiren …“
  // ACHTUNG: phraseMilieu fänkt mat engem Espace un — d’JSX setzt no dem
  // fette Präis keen; op Franséisch hänkt do e Komma un, op Lëtzebuergesch e Wuert.
  'fiche.upsell.badge': '⭐ Am dackste gewielt',
  'fiche.upsell.phraseAvant': 'Fir',
  'fiche.upsell.phraseGras': '{prix} méi',
  'fiche.upsell.phraseMilieu': ' kritt Dir mam',
  'fiche.upsell.phraseApres': 'all d’Accessoiren, déi d’Feier komplett maachen.',
  'fiche.upsell.voir': 'De {nom} kucken →',

  'fiche.caracteristiques.joueursLabel': 'Spiller',
  'fiche.caracteristiques.joueursValeur': '2 bis 10',
  'fiche.caracteristiques.dureeLabel': 'Dauer',
  'fiche.caracteristiques.dureeValeur': '≈ 20 Minutten',
  'fiche.caracteristiques.piecesLabel': 'Stécker',
  'fiche.caracteristiques.piecesValeur': '11 + 1 fir ze rubbelen',
  'fiche.caracteristiques.ageLabel': 'Alter',
  'fiche.caracteristiques.ageValeur': 'Vu 3 Joer un',

  'fiche.etapes.reglesLien': 'Déi komplett Spillregele liesen',
  'fiche.etapes.reglesSuite': '— déi 11 Froe si matgeliwwert, prett fir ze drécken.',

  'fiche.accessoires.titreAvec': '🎁 An dësem Pack ass alles scho prett',
  'fiche.accessoires.titreSans': '🎁 Loscht, datt alles prett ass, wann d’Schachtel opgeet?',
  'fiche.accessoires.introAvec':
    'Dir maacht d’Schachtel op, Dir leet de Froebou op den Dësch, jidderee kritt säi Stoffsäckelchen — an d’Spill fänkt un.',
  'fiche.accessoires.introSans':
    'De Pack Premium bréngt déi dräi Accessoiren derbäi, déi um grousse Dag den Ënnerscheed maachen:',
  'fiche.accessoires.photoContenuAlt':
    'Den Inhalt vum Pack Premium flaach ausgeluecht: d’Schachtel, de gedréckte Froebou an déi zwee Stoffsäckelcher vun den Equipen',
  'fiche.accessoires.photoContenuLegende':
    'De gedréckte Froebou, d’Schachtel an d’Stoffsäckelcher — richteg Foto',
  'fiche.accessoires.photoPochonsAlt':
    'Déi zwee Stoffsäckelcher mat Zuchband, mat den Etiquetten Equipe 1 an Equipe 2',
  'fiche.accessoires.photoPochonsLegende': 'D’Stoffsäckelcher vun den Equipen aus Kotteng — richteg Foto',
  'fiche.accessoires.pochonsTitre': 'Zwee Stoffsäckelcher',
  'fiche.accessoires.pochonsTexte':
    'Mat den Etiquetten Equipe 1 an Equipe 2: jidderee sicht sech beim Ukomme säi Lager eraus, an d’Spill leeft vun eleng un.',
  'fiche.accessoires.questionnaireTitre': 'De Froebou, scho gedréckt',
  'fiche.accessoires.questionnaireTexte':
    'Déi 11 Froen op Kartong vu 400 g, mat de Punktekolonne vun deenen zwou Equipen — an e Blanko-Modell fir Är eege Froen.',
  'fiche.accessoires.enveloppeTitre': 'D’Souvenir-Enveloppe',
  'fiche.accessoires.enveloppeTexte':
    'No der Feier rutscht den ausgefëllte Froebou dran — d’Enveloppe ass dofir geduecht, hannen um Bilderkader befestegt ze ginn.',
  'fiche.accessoires.decouvrir': 'De {nom} entdecken →',

  'fiche.souvenir.photoAlt':
    'De fäerdege Puzzle, agerummt an un d’Mauer vun engem Bebeszëmmer gehaangen',
  'fiche.souvenir.photoLegende':
    'De Puzzle vum grousse Dag — 14 × 21 cm, d’Gréisst vun engem Bilderkader',
  'fiche.souvenir.surtitre': 'A no der Feier?',
  'fiche.souvenir.titre': 'Et bleift e Bild un der Mauer',
  // Saz ëm dat fett „14 × 21 cm“ ronderëm geschnidden (d’Mooss gëtt net iwwersat).
  'fiche.souvenir.tailleAvant': 'De fäerdege Puzzle miesst',
  'fiche.souvenir.tailleApres':
    '— genau d’Gréisst vun engem gewéinleche Bilderkader. Vill Eltere loossen en encadréieren an hänken en an d’Zëmmer vum Bëbee: den Dag, wou jidderee d’Neiegkeet héieren huet, an engem eenzege Bild.',
  // Saz ëm dat fett „d’Souvenir-Enveloppe“ ronderëm geschnidden.
  'fiche.souvenir.premiumAvant':
    'De Froebou vun dësem Pack ass genau dofir geduecht: déi gewonnen Equipe, wien d’Stéck gerubbelt huet, d’Datum — eemol ausgefëllt rutscht Dir en an',
  'fiche.souvenir.premiumEnveloppe': 'd’Souvenir-Enveloppe',
  'fiche.souvenir.premiumApres':
    ', déi hannen um Bilderkader befestegt gëtt. An zéng Joer maacht Dir se zesummen erëm op.',
  'fiche.souvenir.upsell':
    'Mam Pack Premium rutscht de Froebou, deen Dir um grousse Dag ausgefëllt hutt (gewonnen Equipe, wie gerubbelt huet, d’Datum), an d’Souvenir-Enveloppe, hannen um Bilderkader. An zéng Joer maacht Dir se zesummen erëm op.',

  'fiche.specs.titre': '📋 Technesch Fiche',
  'fiche.specs.contenuLabel': 'Inhalt vun der Schachtel',
  'fiche.specs.contenuValeur':
    '11 Puzzlestécker fir ze gewannen + 1 eenzegaartegt Stéck fir ze rubbelen',
  'fiche.specs.principeLabel': 'Prinzip',
  'fiche.specs.principeValeur':
    'Quiz an zwou Equipen, Puzzle fir zesummenzeleeën, Uskënnegung um Enn duerch d’Rubbelen',
  'fiche.specs.reglesLabel': 'Regelen',
  'fiche.specs.reglesValeur':
    'Zesummegefaasst op der Récksäit vun der Schachtel, komplett Versioun online iwwer de QR-Code',
  'fiche.specs.matiereLabel': 'Material',
  'fiche.specs.matiereValeur': 'Kartong — Schachtel a Stécker',
  'fiche.specs.puzzleLabel': 'Zesummegeluechte Puzzle',
  'fiche.specs.puzzleValeur': '14 × 21 cm — d’Gréisst vun engem gewéinleche Bilderkader',
  'fiche.specs.securiteLabel': 'Sécherheet',
  'fiche.specs.securiteValeur':
    'Konform CE / EN 71. Kleng Deeler: net gëeegent fir Kanner ënner 3 Joer',
  'fiche.specs.origineLabel': 'Hierkonft',
  'fiche.specs.origineValeur': 'Konzipéiert a verschéckt aus der Belsch vu Mirum Games',
};
